import { PAGES } from '@/consts';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type AppCompanyCategory = {
    id: number;
    slug: string;
    name: string;
    description: string;
};

export type ApiCompanyCategoriesRequest =
    | {
          page: PAGES;
      }
    | {
          event: number;
      };

export type ApiCompanyCategoriesResponse = ApiResponse<AppCompanyCategory[]>;

export type AppCompanyCategoriesResponse = ApiResponse<AppCompanyCategory[]>;

export const getCompanyCategories = ({
    params,
}: ApiRequestFnParams<ApiCompanyCategoriesRequest> = {}): Promise<AppCompanyCategoriesResponse> =>
    axiosAPI.get<ApiCompanyCategoriesResponse>('/v1/company-categories', { params }).then((res) => res.data);
